import React from 'react';
import { useHeatMapContext } from 'recommendationsNew/components/heatMap/contexts/heatMapContext';
import CloudWaste from './cloudWaste/cloudWaste';
import classNames from 'classnames';
import { WASTE_TABS } from 'recommendationsNew/consts.js';
import ColoredTabs from 'shared/components/tabs/ColoredTabs.jsx';
import WasteMapContent from 'recommendationsNew/components/heatMap/wasteMapContent.jsx';
import TrackingWaste from 'recommendationsNew/components/heatMap/cloudWaste/trackingWaste.tsx';
import { useRecommendationsNewContext } from 'recommendationsNew/contexts/recommendationsNewContext.jsx';
import classes from './heatMap.module.scss';

const HeatMapContent = ({ currentOverrideCurrency, withOverrideApiKey }) => {
  const { isHeatMapClosed, wasteTabSelected, setWasteTabSelected } = useHeatMapContext();

  const { isDashboardPanel } = useRecommendationsNewContext();
  return (
    <div
      className={classNames(
        classes.heatMapContentContainer,
        isHeatMapClosed && classes.close,
        isDashboardPanel && classes.singleTab,
      )}
    >
      {!isDashboardPanel ? (
        <ColoredTabs
          selectedIndex={WASTE_TABS.find((tab) => tab.key === wasteTabSelected)?.id}
          arrOfNavItems={WASTE_TABS}
          defaultAccountIndex={WASTE_TABS.find((tab) => tab.key === wasteTabSelected)?.id}
          automation-id="waste-tabs"
          className={classes.tabContent}
          onTabChange={(selectedId) => setWasteTabSelected(WASTE_TABS.find((tab) => tab.id === selectedId)?.key)}
        >
          <WasteMapContent currentOverrideCurrency={currentOverrideCurrency} withOverrideApiKey={withOverrideApiKey} />
          <CloudWaste />
          <TrackingWaste />
        </ColoredTabs>
      ) : (
        <WasteMapContent />
      )}
    </div>
  );
};

export default HeatMapContent;
